import React, { useState } from 'react'
import axios from 'axios'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { slackDisconnectUrl } from '../../smUninstallEndpoints'
import { getAxiosDefaultConfig } from 'utils'

export default function SlackUninstallModal({ visible, closeModal, integration }) {
  const { channel } = integration || {}

  const [isProcessing, setIsProcessing] = useState(false)
  const [completed, setCompleted] = useState(false)
  const [showError, setShowError] = useState(false)

  const handleConfirm = async () => {
    setIsProcessing(true)
    setShowError(false)

    try {
      await axios.delete(slackDisconnectUrl, getAxiosDefaultConfig())
      setCompleted(true)
      toast.success('Slack disconnected')
    } catch (err) {
      console.error('Error disconnecting Slack:', err)
      setShowError(true)
    } finally {
      setIsProcessing(false)
    }
  }

  const handleClose = () => {
    closeModal()
    if (completed) {
      window.location.reload()
    }
  }

  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Body>
        <div className="tw-p-6">
          <h2 className="tw-text-xl tw-mb-6">Disconnect {channel}</h2>
          {showError && (
            <p className="tw-text-red-600 tw-mb-4">Error disconnecting integration. Please try again.</p>
          )}
          <p className="tw-mb-4">
            {completed ? (
              `${channel} has been disconnected.`
            ) : (
              <>
                This removes your PayHelm Slack connection (notifications and AI chat links for your account).
                {' '}
                If Slack asked you to reinstall after scope changes, remove the app from your Slack workspace first,
                then use Connect again.
              </>
            )}
          </p>
          <div className="tw-flex tw-justify-end tw-space-x-2">
            <Button variant="secondary" size="sm" onClick={handleClose}>
              {completed ? 'Done' : 'Cancel'}
            </Button>
            {!completed && (
              <Button variant="danger" size="sm" onClick={handleConfirm} disabled={isProcessing}>
                {isProcessing ? (
                  <>
                    <Spinner animation="border" size="sm" className="tw-mr-2" />
                    Disconnecting...
                  </>
                ) : (
                  'Disconnect'
                )}
              </Button>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
